module.exports = __webpack_public_path__ + "static/media/dropdown-dots.9e6a0171.svg";